import React from "react";
import { useRive } from "@rive-app/react-canvas";
import "../../../styles/utils/loading/NikiPencilLoading.scss";
import { getLocalizedAssetPath } from "../../../utils/getLocalizedLogo";

export default function NikiPencilLoading() {
  const { RiveComponent } = useRive({
    src: "/images/utils/loading/nikiPencilLoading/pencil_nikki.riv",
    autoplay: true,
  });

  return (
    <div className="niki-pencil-loading-overlay">
      <div className="niki-pencil-loading-content">
        <div className="niki-pencil-loading-animation">
          <RiveComponent />
        </div>
        <figure className="niki-pencil-loading-text">
          <img
            src="/images/utils/loading/nikiPencilLoading/loading.svg"
            alt="loading"
          />
        </figure>
        <figure className="niki-pencil-loading-title">
          <img
            src={getLocalizedAssetPath("/images/utils/loading/nikiPencilLoading/title.svg")}
            alt="니키와 마법연필이 멋지게 동화를 만들고 있어요!"
          />
        </figure>
        <figure className="niki-pencil-loading-book">
          <img
            src="/images/utils/loading/nikiPencilLoading/book.svg"
            alt="책"
          />
        </figure>
      </div>
    </div>
  );
}
